import { AutogenModelServicefailStopUser, AutogenRowServicefailStopUser } from "./autogen/AutogenModelServicefailStopUser";

export class ModelServicefailStopUser extends AutogenModelServicefailStopUser<RowServicefailStopUser> {
	constructor() {
		super(RowServicefailStopUser);
	}
}

export class RowServicefailStopUser extends AutogenRowServicefailStopUser {
}